"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MetaCategory = /** @class */ (function () {
    function MetaCategory(metaCategoryId, displayNameMsgId, hasCustomSorting, hasIcon, defaultIconPath, wfProcessId, isCacheable, nameMetaFieldIds, isWithVersioning, isClassifier, keyMetaFields, actionDataMetaFieldIds, transientMetaFieldIds, displayNameMultilingual, showInCategoryManager, searchableFieldIds, isRoot) {
        this.metaCategoryId = metaCategoryId;
        this.displayNameMsgId = displayNameMsgId;
        this.hasCustomSorting = hasCustomSorting;
        this.hasIcon = hasIcon;
        this.defaultIconPath = defaultIconPath;
        this.wfProcessId = wfProcessId;
        this.isCacheable = isCacheable;
        this.nameMetaFieldIds = nameMetaFieldIds;
        this.isWithVersioning = isWithVersioning;
        this.isClassifier = isClassifier;
        this.keyMetaFields = keyMetaFields;
        this.actionDataMetaFieldIds = actionDataMetaFieldIds;
        this.transientMetaFieldIds = transientMetaFieldIds;
        this.displayNameMultilingual = displayNameMultilingual;
        this.showInCategoryManager = showInCategoryManager;
        this.searchableFieldIds = searchableFieldIds;
        this.isRoot = isRoot;
    }
    MetaCategory.prototype.getSystemName = function () {
        return this.metaCategoryId.getSystemName();
    };
    MetaCategory.prototype.getMetaCategoryId = function () {
        return this.metaCategoryId;
    };
    MetaCategory.prototype.getHasCustomSorting = function () {
        return this.hasCustomSorting;
    };
    MetaCategory.prototype.getDisplayNameMsgId = function () {
        return this.displayNameMsgId;
    };
    MetaCategory.prototype.getHasIcon = function () {
        return this.hasIcon;
    };
    MetaCategory.prototype.getDefaultIconPath = function () {
        return this.defaultIconPath;
    };
    MetaCategory.prototype.getWFProcessId = function () {
        return this.wfProcessId;
    };
    MetaCategory.prototype.getNameMetaFieldIds = function () {
        return this.nameMetaFieldIds;
    };
    MetaCategory.prototype.getIsCacheable = function () {
        return this.isCacheable;
    };
    MetaCategory.prototype.getIsWithVersioning = function () {
        return this.isWithVersioning;
    };
    MetaCategory.prototype.getIsClassifier = function () {
        return this.isClassifier;
    };
    MetaCategory.prototype.getKeyMetaFieldIds = function () {
        return this.keyMetaFields;
    };
    MetaCategory.prototype.getActionDataMetaFieldIds = function () {
        return this.actionDataMetaFieldIds;
    };
    MetaCategory.prototype.getTransientMetaFieldIds = function () {
        return this.transientMetaFieldIds;
    };
    MetaCategory.prototype.getDisplayNameMultilingual = function () {
        return this.displayNameMultilingual;
    };
    MetaCategory.prototype.getShowInCategoryManager = function () {
        return this.showInCategoryManager;
    };
    MetaCategory.prototype.getSearchableFieldIds = function () {
        return this.searchableFieldIds;
    };
    Object.defineProperty(MetaCategory.prototype, "getIsRoot", {
        get: function () {
            return this.isRoot;
        },
        enumerable: true,
        configurable: true
    });
    return MetaCategory;
}());
exports.MetaCategory = MetaCategory;
//# sourceMappingURL=meta-category.js.map